import IdentifiableDto from 'modules/base/dto/IdentifiableDto';
import ValaszListItemDto from '../../egyszerukerdes/dto/ValaszListItemDto';
import ElemiValaszListItemDto from './ElemiValaszListItemDto';

export class TobbszorosKerdesEditDto extends IdentifiableDto {
	constructor() {
		super();
		
		this.sorszam = null;
		this.alSorszam = null;
		this.subSorszam = 0;
		this.csorszam = null;
		
		this.leiras = null;
        this.magyarazat = null;
		this.valasz = null;
        this.kerdesElemiValasz = null;

		this.nemperm = false;
		this.statuszId = false;
		
		this.feladatCsoport = null;
		this.fejezet = null;
	}

	setup(props) {
		super.setup(props);
		
		this.sorszam = props.sorszam;
		this.alSorszam = props.alSorszam;
		this.subSorszam = props.subSorszam;
		this.csorszam = props.csorszam;
		
		this.leiras = props.leiras;
        this.magyarazat = props.magyarazat;
		this.valasz = props.valasz != null ? props.valasz.map(d => new ValaszListItemDto().setup(d)) : [];
        this.kerdesElemiValasz = props.kerdesElemiValasz != null ? props.kerdesElemiValasz.map(d => new ElemiValaszListItemDto().setup(d)) : [];

		this.nemperm = props.nemperm;
		this.statuszId = props.statuszId;
		
		this.feladatCsoport = props.feladatCsoport;
		this.fejezet = props.fejezet;

		return this;
	}
}

export default TobbszorosKerdesEditDto;
